var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.innerWidth > 1000)?_c('div',[_c('HomePc')],1):_c('div',[_c('HomeM')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }